import { register } from '../../../Utils'
const fetch = require('node-fetch')

const CongressRegistrationForm = el => {
  /* General variables */
  const formWrapper = document.getElementById('congress-registration-form')
  const form = formWrapper.querySelector('form')
  const formId = form.id
  const formSubmit = form.querySelector('button[type="submit"]')

  /* Fieldset variables */
  const fieldsetBillingAddress = document.getElementById(`${formId}-fieldset-billing`)
  const fieldsetWorkshop = document.getElementById(`${formId}-fieldset-workshop`)

  /* Single item variables */
  const itemCheckboxBillingAddress = document.getElementById(`${formId}-checkbox-shipping-billing`)
  const itemCheckboxWorkshopRegistration = document.getElementById(`${formId}-checkbox-workshop-registration`)
  const itemSelectCountry = document.getElementById(`${formId}-singleselectstaticinfocountry-workshop`)
  const itemConfirmAGB = document.getElementById(`${formId}-checkbox-agb`)
  const itemInputEmail = document.getElementById(`${formId}-email-email`)

  /* Data variables */
  const workshopCountries = JSON.parse(itemSelectCountry.dataset.subset)
  const emailCheckURL = '/registration?tx_form_formframework%5Baction%5D=ajaxCheckAccount&tx_form_formframework%5Bcontroller%5D=Registration&type=1608120337'

  /* ErrorBox variables */
  const errorBox = formWrapper.querySelector(`.error-box`)
  const errorBoxContent = formWrapper.querySelector(`.error-box-content`)
  const errorText = 'This E-Mail Address already exists!'

  /* Generic functions */

  /**
   * Changes the state of the item, e.g. checks or unchecks a checkbox
   *
   * @param {element} item The item to be changed
   * @param {boolean} activate Activate or deactivate the item
   */
  const changeItemStatus = (item, activate = true) => {
    switch (item.type) {
      case 'checkbox':
        if (activate) {
          item.checked = true
        } else {
          item.checked = false
        }
        break
      default:
        break
    }
  }

  /**
   * Changes the visibility of the item by adding a class
   *
   * @param {element} item The item to be changed
   * @param {boolean} makeVisible Make it visible or invisible
   */
  const changeVisibility = (item, makeVisible = true) => {
    if (makeVisible) {
      item.classList.remove('is--hidden')
    } else {
      item.classList.add('is--hidden')
    }
  }

  /**
   * Makes items inside the fieldset mandatory or non-mandatory for tx_forms
   *
   * @param {element} fieldset The fieldset that contains the items
   * @param {array} exceptions IDs of items that should be ignored
   * @param {boolean} mandatory Make the items mandatory or non-mandatory
   */
  const changeFieldsetMandatory = (fieldset, exceptions = [], mandatory = true) => {
    const inputs = fieldset.querySelectorAll('input:not([type="hidden"]), select:not([type="hidden"])')

    inputs.forEach(input => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`)

      if (!exceptions.includes(input.id)) {
        input.required = mandatory

        if (mandatory) {
          if (!label.querySelector('span.required')) {
            const requiredSpan = document.createElement('SPAN')
            requiredSpan.classList.add('required')
            requiredSpan.textContent = ' *'
            label.appendChild(requiredSpan)
          }
        } else {
          const requiredSpan = label.querySelector('span.required')
          if (requiredSpan) {
            requiredSpan.remove()
          }
        }
      }
    })
  }

  /**
   * Adds a css-class to parent of a defined element (both selected by query selector)
   *
   * @param {string} element Selector for the child item
   * @param {string} parent Selector for the parent item
   * @param {string} newClass Class that should be added to the parent element
   */
  const addClassToElementsParent = (element, parent, newClass) => {
    const elements = el.querySelectorAll(element)

    elements.forEach(element => {
      const parentElement = element.closest(parent)
      parentElement.classList.add(newClass)
    })
  }

  /* Listener Actions & Registrations. Contains the logic what happens when. Non generic. */
  const changeCountrySelect = () => {
    if (workshopCountries.includes(itemSelectCountry.value)) {
      changeVisibility(fieldsetWorkshop)
    } else {
      itemCheckboxWorkshopRegistration.checked = false
      itemCheckboxBillingAddress.checked = true
      changeVisibility(fieldsetWorkshop, false)
      changeVisibility(fieldsetBillingAddress, false)
      changeFieldsetMandatory(fieldsetWorkshop, [], false)
      changeFieldsetMandatory(fieldsetBillingAddress, [], false)
    }
  }

  itemSelectCountry.addEventListener('change', changeCountrySelect)

  const changeWorkshopRegistrationCheckbox = () => {
    if (itemCheckboxWorkshopRegistration.checked) {
      changeFieldsetMandatory(fieldsetWorkshop, [`${formId}-checkbox-workshop-registration`, `${formId}-text-address2-shipping`, `${formId}-checkbox-shipping-billing`])
      if (!itemCheckboxBillingAddress.checked) {
        changeFieldsetMandatory(fieldsetBillingAddress, [`${formId}-text-address2-billing`])
      }
    } else {
      changeFieldsetMandatory(fieldsetWorkshop, [], false)
      changeFieldsetMandatory(fieldsetBillingAddress, [], false)
    }
  }

  itemCheckboxWorkshopRegistration.addEventListener('change', changeWorkshopRegistrationCheckbox)

  const changeBillingAddressCheckbox = () => {
    if (!itemCheckboxBillingAddress.checked) {
      changeVisibility(fieldsetBillingAddress)
      if (itemCheckboxWorkshopRegistration.checked) {
        changeFieldsetMandatory(fieldsetBillingAddress, [`${formId}-text-address2-billing`])
      }
    } else {
      changeVisibility(fieldsetBillingAddress, false)
      changeFieldsetMandatory(fieldsetBillingAddress, [], false)
    }
  }

  itemCheckboxBillingAddress.addEventListener('change', changeBillingAddressCheckbox)

  /* Add a link to the AGB checkbox text */
  const addLinksToAGBCheckbox = (e) => {
    let string = e.nextElementSibling.innerHTML
    string = string.replace('###privacy###', '<a href="/privacy-policy" target="_blank">Privacy Policy</a>').replace('###change_cancellation###', '<a href="/change-cancellation-policy" target="_blank">Change & Cancellation Policy</a>')
    e.nextElementSibling.innerHTML = string
  }

  /* Move tooltip component from bottom of template after the password label */
  const relocateTooltip = () => {
    const passwordTooltip = document.getElementById(`${formId}-password-tooltip`)
    const passwordLabel = form.querySelector(`label[for="${formId}-password-password"]`)

    if (passwordTooltip && passwordLabel) {
      passwordLabel.appendChild(passwordTooltip)
    }
  }

  /* Check if the Email Adress already exists and enable the submit button if it does not */
  const checkMailValidity = () => {
    const reqURL = `${emailCheckURL}&tx_form_formframework%5Bemail%5D=${itemInputEmail.value}`

    fetch(reqURL)
      .then(response => {
        if (response.ok) {
          return response.text()
        }

        throw new Error('Received no response.')
      })
      .then(text => {
        if (text.startsWith('OK')) {
          formSubmit.disabled = false
        } else {
          formSubmit.disabled = true
          /* Notification box auslagern */
          errorBoxContent.textContent = errorText
          errorBox.classList.add(`${errorBox.dataset.prefix}is--open`)
          setTimeout(() => {
            errorBox.classList.remove(`${errorBox.dataset.prefix}is--open`)
          }, 5000)
        }
      })
      .catch(error => {
        console.log('Request failed', error)
      })
  }

  itemInputEmail.addEventListener('blur', checkMailValidity)

  /* Init */
  formSubmit.disabled = true
  addClassToElementsParent('.input.checkbox', '.form-group', 'is--fullwidth')
  addLinksToAGBCheckbox(itemConfirmAGB)
  changeCountrySelect()
  changeWorkshopRegistrationCheckbox()
  changeBillingAddressCheckbox()
  relocateTooltip()
}

register('CongressRegistrationForm', CongressRegistrationForm)
